module.exports = __webpack_public_path__ + "img/hsyz-icon.b381fb04.png";